import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CampaignsService } from 'src/app/services/campaigns.service';
import { MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { MainService } from 'src/app/services/main.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import {map, startWith} from 'rxjs/operators';

interface Producto {
  buho_sku: string,
  legacy_sku: string,
  product_name: string,
  product_id: number,
  family_id: number,
  planta: string,
  image_url: string,
  family: string
}

@Component({
  selector: 'app-distribution-art-product',
  templateUrl: './distribution-art-product.component.html',
  styleUrls: ['./distribution-art-product.component.scss']
})
export class DistributionArtProductComponent implements OnInit {

  productSelect: any = null;
  newObj = {};
  blob: string = '';
  form!: FormGroup;
  fileUrl: SafeResourceUrl = '';
  materialControl = new FormControl();
  productos: Producto[] = [];
  filteredOptions!: Observable<Producto[]>;

  bodyForm : FormData = new FormData(); 
  isToggleChecked: boolean = false;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data : any,
      private campaignService : CampaignsService,
      private dialogRef: MatDialogRef<DistributionArtProductComponent>,
      private main : MainService,
      public sanitizer: DomSanitizer,
      private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.getSkus();
    this.initSelect();
    this.loadForm();
  }

  loadForm() {
    this.form = this.fb.group({
      blob: [null, Validators.required]
    });
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) {
      return;
    }

    if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
      Swal.fire({
        icon: 'warning',
        title: 'Error',
        html: 'Solo se permiten documentos en formato .PDF'
      });
      input.value = '';
      return;
    }

    this.form.get('blob')?.setValue([file]);
    this.form.get('blob')?.markAsDirty();
  }

  getSkus(){
    this.main.ShowLoading();
    this.campaignService.getSkus().subscribe(
      (result:any) => {
        this.productos = result.data2.sku_catalog;

        // Creamos un Map indexado por family_id para eliminar duplicados
        /* this.productos = Array.from(
          new Map(
            result.data2.sku_catalog.filter((item:any) => item.family_id !== null && item.family_id !== undefined && item.clientes == this.data.strategy.compania).map((item:any) => [
              item.family_id, 
              { product_id: item.product_id, family_id: item.family_id, family: item.family, image_url: item.image_url, alto: item.alto, ancho: item.ancho, planta: item.planta, acabado: item.acabado, tintas: item.tintas, unidad: item.unidad }
            ])
          ).values()
        ) as Producto[]; */

        const productosFiltrados = result.data2.sku_catalog.filter(
          (item: any) =>
            item.family_id !== null &&
            item.family_id !== undefined &&
            item.clientes == this.data.strategy.compania
        );

        const medidasPorFamilia = new Map<number, Set<string>>();

        productosFiltrados.forEach((item: any) => {
          let medidas = medidasPorFamilia.get(item.family_id);

          if (!medidas) {
            medidas = new Set<string>();
            medidasPorFamilia.set(item.family_id, medidas);
          }

          medidas.add(JSON.stringify([item.alto ?? null, item.ancho ?? null]));
        });

        this.productos = Array.from(
          new Map(
            productosFiltrados.map((item: any) => [
              item.family_id,
              {
                product_id: item.product_id,
                family_id: item.family_id,
                family: item.family,
                image_url: item.image_url,
                alto: item.alto,
                ancho: item.ancho,
                planta: item.planta,
                acabado: item.acabado,
                tintas: item.tintas,
                unidad: item.unidad
              }
            ])
          ).values()
        ).map((producto: any) => ({
          ...producto,
          varias: (medidasPorFamilia.get(producto.family_id)?.size ?? 0) > 1
        })) as Producto[];

        this.productos.sort((a, b) => {
          const nombreA = a.family.toLowerCase();
          const nombreB = b.family.toLowerCase();

          if (nombreA < nombreB) {
              return -1;
          }
          if (nombreA > nombreB) {
              return 1;
          }
          return 0;
        });
       
        if (this.productos.length > 0) {
          this.main.HideLoading();
        }
      },
      (err:any) => {
          this.main.HideLoading();
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener registros',
            text: 'Ocurrió un error al obtener los registros.'
          });
      }
    );
  }

  seleccionarOpcion(event: MatAutocompleteSelectedEvent): void {
    this.main.ShowLoading();
    const productoSeleccionado: Producto = event.option.value; 
    this.productSelect = productoSeleccionado;

    const baseUrl = 'https://buhov18test.odoo.com';

    //console.log("productoSeleccionado", productoSeleccionado);

    const fullImageUrl = baseUrl + this.productSelect.image_url;
    this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fullImageUrl);
    this.main.HideLoading();
  }

  getSourceURL(fileUrl: SafeResourceUrl): SafeResourceUrl {
    return fileUrl;
  }

  clearAutocomplete(event?: Event) {
    if (event) {
        event.stopPropagation();
    }
    this.materialControl.setValue(null);     
    this.productSelect = null;
  }

  // Muestra el nombre del objeto cuando ha sido seleccionado
  displayFn(producto: Producto): string {
    return producto && producto.family ? producto.family : '';
  }

  initSelect(){
    this.filteredOptions = this.materialControl.valueChanges.pipe(
      startWith(''), 
      map(value => {
        const name = typeof value === 'string' ? value : value?.family || ''; 
        return name ? this._filter(name as string) : this.productos.slice();
      })
    );
  }

  private _filter(value: string): Producto[] {
    const filterValue = value.toLowerCase();

    return this.productos.filter(producto => 
      //Aqui comparamos la propiedad 'family' del objeto con el texto del input
      producto.family.toLowerCase().includes(filterValue)
    );
  }

  openDropdown(): void {
    if (!this.materialControl.value) {
        this.materialControl.setValue('');
    }
  }

  preloadFormData() {
    this.bodyForm.append('folder_str', this.data.strategy.folder as string);
    this.bodyForm.append('id_sku', this.productSelect.product_id);
    this.bodyForm.append('medida_x', this.productSelect.ancho);
    this.bodyForm.append('medida_y', this.productSelect.alto);
    this.bodyForm.append('idFamily', this.productSelect.family_id);
    this.bodyForm.append('validaEnfocus', this.isToggleChecked == true ? '1' : '0');
    this.bodyForm.append('family', this.productSelect.family);
  }

  saveDistributionArt(idStrategy: string) {
    this.bodyForm.append('id_str', idStrategy);
    Swal.fire({
      title: '¿Seguro que quiere subir este archivo?',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
      cancelButtonText: `Cancelar`
    }).then((result) => {
      if (result.isConfirmed) {
        if (this.form.value.blob != null && this.form.value.blob?.length != 0) {
          this.preloadFormData()
          this.bodyForm.append("blob", this.form.value.blob[0] as File);
          Swal.fire({
            icon: 'info',
            title: 'Subiendo archivo...',
            text:'Espere un momento por favor.',
            allowEscapeKey: false,
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
          this.campaignService.uploadArtFile(this.bodyForm).subscribe(
            (result: any) => {
              if (result.message == 'Success') {
                Swal.fire({
                    icon: 'success',
                    title: 'Archivo subido',
                    text: 'Archivo subido exitosamente'
                  }).then(() => {
                    this.form.reset();
                    this.dialogRef.close({ artes: true });
                  });
                  //console.log("upload data", result);
              }
              else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
                });
              }
            },
            (err: any) => {
              this.main.HideLoading();
              Swal.fire({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
              });
            }
          )

        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Error',
            html: 'El documento no ha sido adjuntado'
          });
        }

      }
    });
  }

  onToggleChange(event: any) {
    this.isToggleChecked = event.checked;
  }

}
